import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-5 flex flex-wrap" }
const _hoisted_2 = { class: "ml-auto" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Create ")

import { toRefs, computed, watch, nextTick } from "vue";
import { useStore }                          from "vuex";
import { useConfig }                         from "../../config";

// Components
import { AppButton as Button } from "@greywind/ui";


export default /*#__PURE__*/_defineComponent({
  props: {
        model: {
            type:     Object,
            required: true
        }
    },
  emits: [ 'close', 'created' ],
  setup(__props, { emit }) {

const props = __props



const { model }  = toRefs( props );
const { config } = useConfig();
const store      = useStore();


const path = computed( () => store.state.media.path );

watch( () => config.value.name, value => nextTick( () => {
    config.value.name = config.value.name.replace( /[^a-zA-Z0-9 ]/g, '' );
} ) );

// Functions
const submitHandler = async (): void => {
    config.value.loading = true;

    try {
        await model.value.createPath( { path: path.value, name: config.value.name } );

        emit( 'close' );
        emit( 'created' );
    } catch ( e ) {
        console.log( e );
    } finally {
        config.value.loading = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_text_field = _resolveComponent("text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_text_field, {
      class: "text-center",
      id: "field-name",
      field: { value: _unref(config).name, required: true, clear: true, name: 'folder_name', indexName: '', extraAttributes: { placeholder: 'Folder Name' } },
      modelValue: _unref(config).name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(config).name) = $event))
    }, null, 8, ["field", "modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        id: "new-folder-button",
        size: "small",
        disabled: !_unref(config).name.length || _unref(config).loading,
        loading: _unref(config).loading,
        onClick: submitHandler
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ]))
}
}

})